// extracted by mini-css-extract-plugin
export var addressFields = "_oo-0";
export var animationContainer = "_oo-1";
export var footer = "_oo-2";
export var lineItems = "_oo-3";
export var modalContent = "_oo-4";
export var orderName = "_oo-5";
export var strong = "_oo-6";
export var warning = "_oo-7";